import { writable } from "svelte/store";
import type { RetailerType } from "@shared/types/Retailer";

const createCurrentRetailerStore = (initValue: RetailerType | null) => {
  const { set, subscribe, update } = writable(initValue);

  return {
    set,
    subscribe,
    update,
  };
};

export default createCurrentRetailerStore(null);
